module.exports = __webpack_public_path__ + "static/media/18_themoon.98a0e359.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/18_themoon.png
// module id = 81
// module chunks = 0